
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.658 4.76H13V0H9.072v.017C4.312.18 3.337 2.76 3.25 5.47h-.01v2.376H0v4.661h3.241V25h4.884V12.506h4.002l.772-4.66H8.127V6.408c0-.915.632-1.65 1.531-1.65z","fill":"#52B788"}})])
          )
        }
      }
    